import { render, staticRenderFns } from "./PDP.vue?vue&type=template&id=c20decf4&"
import script from "./PDP.vue?vue&type=script&lang=js&"
export * from "./PDP.vue?vue&type=script&lang=js&"
import style0 from "./PDP.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports